import { render, staticRenderFns } from "./PriceCategoryCollapse.vue?vue&type=template&id=7a7b06a5&"
import script from "./PriceCategoryCollapse.vue?vue&type=script&lang=js&"
export * from "./PriceCategoryCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports